import { motion, AnimatePresence } from "framer-motion";

/**
 * SceneStage — renders the active scene with full-stage cinematic transitions.
 *
 * Each scene exits and enters with:
 *   - opacity fade
 *   - subtle parallax/scale
 *   - direction-aware translate
 */
const variants = {
  enter: (dir) => ({
    opacity: 0,
    scale: 1.02,
    x: dir > 0 ? 36 : -36,
    filter: "blur(8px)",
  }),
  center: {
    opacity: 1,
    scale: 1,
    x: 0,
    filter: "blur(0px)",
  },
  exit: (dir) => ({
    opacity: 0,
    scale: 0.985,
    x: dir > 0 ? -36 : 36,
    filter: "blur(8px)",
  }),
};

export const SceneStage = ({ index, direction, scene, onAdvance, advanceGuardRef }) => {
  const SceneComponent = scene?.component;
  return (
    <div
      className="absolute inset-0 overflow-hidden"
      data-testid="scene-stage"
    >
      <AnimatePresence mode="wait" initial={false} custom={direction}>
        <motion.div
          key={`scene-${index}`}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            duration: 0.85,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="absolute inset-0"
          data-testid={`scene-${index}-${scene?.id || "unknown"}`}
        >
          {SceneComponent ? (
            <SceneComponent
              onAdvance={onAdvance}
              advanceGuardRef={advanceGuardRef}
              {...(scene?.props || {})}
            />
          ) : null}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SceneStage;
